module.exports = __webpack_public_path__ + "a1b64225bb20af6efdedc9dd383ec6ab.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio1/08_MCA-Selfless-in-the-Bath-Of-Lava.ogg
// module id = 789
// module chunks = 0